import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';

const featuredManga = mangaList.filter((m) => m.featured);

const categoryMap: Record<string, string> = {
  riman: '日漫',
  hanman: '韩漫',
  guoman: '国漫',
};

export default function FeaturedManga() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              热门推荐
            </h2>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
          {featuredManga.map((manga) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              className="group block"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  title={`${manga.title} - 樱花漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-background-50">
                    {categoryMap[manga.category] || manga.category}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <button
                    className="w-7 h-7 flex items-center justify-center rounded-full bg-background-950/40 backdrop-blur-sm text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <i className="ri-heart-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
                  </button>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
                  <span className="text-xs text-background-200">{manga.latestChapter}</span>
                </div>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                {manga.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-foreground-500">{manga.author}</span>
                <span className="text-xs text-accent-500 font-medium">
                  <i className="ri-star-fill w-3 h-3 inline-flex items-center justify-center mr-0.5"></i>
                  {manga.rating}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}